// extracted by mini-css-extract-plugin
module.exports = {"job":"AssignedJob_job__3voNW","time":"AssignedJob_time__279K0","notes":"AssignedJob_notes__1mae0","none":"AssignedJob_none__2nSoW"};